import { defineComponent as _defineComponent } from 'vue'
import {useSimulationStore} from '@/components/calculator/services/SimulationStore';
import {useHouseholds} from '@/components/calculator/form/useSimulationForm';
import MultiformListManager from '@/modules/multiForm/views/MultiformListManager.vue';
import {IMultiformDictionary} from '@/modules/multiForm/shared/IMultiformDictionary';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';
import {useInstance} from '@/composables/useInstance';

export default /*#__PURE__*/_defineComponent({
  __name: 'SimulationFormStep4',
  setup(__props) {

const store = useSimulationStore();
const {households,} = useHouseholds();
const {$env,} = useInstance();

const hasMerged = {
  liabilities: $env?.getAppDomainConfig().calculator.hasMergedLiabilities,
  limits: $env?.getAppDomainConfig().calculator.hasMergedLimits,
};
const hasLiabilitiesOptions: IMultiformDictionary<boolean> = [{
  type: true,
  name_pl: I18NGetter().useSimulationFormStep4.MULTI_FORM_LIABILITIES,
},
{type: false, name_pl: I18NGetter().useSimulationFormStep4.MULTI_FORM_NO_LIABILITIES,},];


return { __sfc: true,store, households, $env, hasMerged, hasLiabilitiesOptions, MultiformListManager, I18NGetter }
}

})